import { ListProps, Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { CameraView, PatrolTimeForecast, PhotoSnapShotByPTZ, ViewPreset } from '@EcamModel/model/CameraView';
import { AxiosInstance } from 'axios';
import {
    ICameraViewHttpController,
    IGetPhotoSnapShotByPTZ,
    IUpdateLatestPhoto,
    IUpdateOrder,
} from '../ICameraViewHttpController';
import { ISendActionGet } from '../IPTZCamConfigureRequestHttpController';

export class CameraViewHttpController extends BaseHttpController<CameraView> implements ICameraViewHttpController {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'camera-view', client);
    }

    async getListPreset(props: ISendActionGet): Promise<ViewPreset[]> {
        return this.doPost({ path: 'get-list-preset', body: props }).then((res) => res.data);
    }

    async getPhotoSnapShotByPTZ(props: IGetPhotoSnapShotByPTZ): Promise<PhotoSnapShotByPTZ> {
        return this.doPost({ path: 'get-photo-snapshot-by-ptz', body: props }).then((res) => res.data);
    }

    async list(props: ListProps<CameraView>): Promise<Paging<CameraView>> {
        return this.doPost({ path: 'list', body: props }).then((res) => res.data);
    }
    async updateLatestPhoto(props: IUpdateLatestPhoto): Promise<CameraView> {
        return this.doPost({ path: 'update-latest-photo', body: props }).then((res) => res.data);
    }
    async updateOrder(props: IUpdateOrder): Promise<true> {
        return this.doPost({ path: 'update-order', body: props }).then((res) => res.data);
    }
    async getPatrolTimeForecast(props: { CameraId: number }): Promise<PatrolTimeForecast> {
        return this.doPost({ path: 'get-patrol-time-forecast', body: props }).then((res) => res.data);
    }
}
